export const FeatureName = 'userPreferences';
